import React from "react";

import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const ChevronLeftIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M20.678 25.735a1 1 0 0 0 .057-1.413L13.057 16l7.678-8.322a1 1 0 1 0-1.47-1.356l-7.785 8.437a1.843 1.843 0 0 0 0 2.482l7.785 8.437a1 1 0 0 0 1.413.057Z" />
  </BaseIcon>
);
